import { render, staticRenderFns } from "./flightSearch.vue?vue&type=template&id=24ec97d6&scoped=true&"
import script from "./flightSearch.vue?vue&type=script&lang=ts&"
export * from "./flightSearch.vue?vue&type=script&lang=ts&"
import style0 from "./flightSearch.vue?vue&type=style&index=0&id=24ec97d6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24ec97d6",
  null
  
)

export default component.exports